import { render, staticRenderFns } from "./Suspense.vue?vue&type=template&id=2cc3617e&scoped=true&lang=pug&"
import script from "./Suspense.vue?vue&type=script&lang=ts&"
export * from "./Suspense.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3617e",
  null
  
)

export default component.exports